package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.RotateOutline: ImageVector
    get() {
        if (_rotateOutline != null) {
            return _rotateOutline!!
        }
        _rotateOutline = Builder(name = "RotateOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 18.0f, viewportHeight = 18.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(9.0836f, 13.7653f)
                lineTo(3.4817f, 8.1519f)
                curveTo(3.3557f, 8.0251f, 3.2584f, 7.8811f, 3.1896f, 7.7197f)
                curveTo(3.1209f, 7.5584f, 3.0865f, 7.3913f, 3.0865f, 7.2184f)
                curveTo(3.0865f, 7.0455f, 3.1209f, 6.8785f, 3.1896f, 6.7173f)
                curveTo(3.2584f, 6.5561f, 3.3557f, 6.4122f, 3.4817f, 6.2856f)
                lineTo(6.2856f, 3.4817f)
                curveTo(6.4123f, 3.3538f, 6.5564f, 3.2579f, 6.7177f, 3.194f)
                curveTo(6.8791f, 3.13f, 7.0462f, 3.0981f, 7.219f, 3.0981f)
                curveTo(7.3919f, 3.0981f, 7.5589f, 3.13f, 7.7201f, 3.194f)
                curveTo(7.8813f, 3.2579f, 8.0252f, 3.3538f, 8.1519f, 3.4817f)
                lineTo(13.7538f, 9.0836f)
                curveTo(13.8798f, 9.2104f, 13.9772f, 9.3545f, 14.0459f, 9.5158f)
                curveTo(14.1146f, 9.6771f, 14.149f, 9.8442f, 14.149f, 10.0171f)
                curveTo(14.149f, 10.19f, 14.1146f, 10.357f, 14.0459f, 10.5182f)
                curveTo(13.9772f, 10.6794f, 13.8798f, 10.8233f, 13.7538f, 10.95f)
                lineTo(10.95f, 13.7653f)
                curveTo(10.8232f, 13.8932f, 10.6791f, 13.9891f, 10.5178f, 14.0531f)
                curveTo(10.3565f, 14.117f, 10.1894f, 14.149f, 10.0165f, 14.149f)
                curveTo(9.8436f, 14.149f, 9.6766f, 14.117f, 9.5154f, 14.0531f)
                curveTo(9.3542f, 13.9891f, 9.2103f, 13.8932f, 9.0836f, 13.7653f)
                verticalLineTo(13.7653f)
                moveTo(9.8509f, 12.9519f)
                curveTo(9.8942f, 12.9952f, 9.9495f, 13.0168f, 10.0168f, 13.0168f)
                curveTo(10.0841f, 13.0168f, 10.1394f, 12.9952f, 10.1827f, 12.9519f)
                lineTo(12.9519f, 10.1827f)
                curveTo(12.9952f, 10.1394f, 13.0168f, 10.0841f, 13.0168f, 10.0168f)
                curveTo(13.0168f, 9.9495f, 12.9952f, 9.8942f, 12.9519f, 9.8509f)
                lineTo(7.3846f, 4.2836f)
                curveTo(7.3413f, 4.2404f, 7.286f, 4.2187f, 7.2187f, 4.2187f)
                curveTo(7.1514f, 4.2187f, 7.0961f, 4.2404f, 7.0528f, 4.2836f)
                lineTo(4.2836f, 7.0528f)
                curveTo(4.2404f, 7.0961f, 4.2187f, 7.1514f, 4.2187f, 7.2187f)
                curveTo(4.2187f, 7.286f, 4.2404f, 7.3413f, 4.2836f, 7.3846f)
                lineTo(9.8509f, 12.9519f)
                verticalLineTo(12.9519f)
                moveTo(8.625f, 17.2499f)
                curveTo(7.439f, 17.2499f, 6.322f, 17.0253f, 5.2738f, 16.5761f)
                curveTo(4.2256f, 16.1269f, 3.3092f, 15.51f, 2.5246f, 14.7253f)
                curveTo(1.74f, 13.9407f, 1.123f, 13.0243f, 0.6738f, 11.9761f)
                curveTo(0.2246f, 10.928f, 0.0f, 9.8109f, 0.0f, 8.625f)
                horizontalLineTo(1.125f)
                curveTo(1.125f, 9.5702f, 1.293f, 10.4682f, 1.6291f, 11.3192f)
                curveTo(1.9651f, 12.1702f, 2.4264f, 12.9255f, 3.013f, 13.5851f)
                curveTo(3.5995f, 14.2447f, 4.2952f, 14.7906f, 5.1f, 15.2228f)
                curveTo(5.9048f, 15.655f, 6.776f, 15.9288f, 7.7135f, 16.0442f)
                lineTo(5.4346f, 13.7653f)
                lineTo(6.225f, 12.975f)
                lineTo(10.3182f, 17.0682f)
                curveTo(10.0413f, 17.124f, 9.761f, 17.1682f, 9.4774f, 17.2009f)
                curveTo(9.1937f, 17.2336f, 8.9096f, 17.2499f, 8.625f, 17.2499f)
                verticalLineTo(17.2499f)
                moveTo(16.125f, 8.625f)
                curveTo(16.125f, 7.6798f, 15.9569f, 6.7817f, 15.6209f, 5.9307f)
                curveTo(15.2848f, 5.0798f, 14.8235f, 4.3245f, 14.237f, 3.6649f)
                curveTo(13.6504f, 3.0052f, 12.9548f, 2.4593f, 12.1499f, 2.0271f)
                curveTo(11.3451f, 1.5949f, 10.474f, 1.3211f, 9.5365f, 1.2057f)
                lineTo(11.8153f, 3.4846f)
                lineTo(11.025f, 4.275f)
                lineTo(6.9317f, 0.1817f)
                curveTo(7.2035f, 0.1212f, 7.4831f, 0.0757f, 7.7705f, 0.0454f)
                curveTo(8.0579f, 0.0151f, 8.3428f, 0.0f, 8.625f, 0.0f)
                curveTo(9.8144f, 0.0f, 10.9319f, 0.2248f, 11.9776f, 0.6743f)
                curveTo(13.0233f, 1.1238f, 13.9387f, 1.7411f, 14.7238f, 2.5262f)
                curveTo(15.5088f, 3.3113f, 16.1262f, 4.2267f, 16.5757f, 5.2723f)
                curveTo(17.0252f, 6.318f, 17.2499f, 7.4356f, 17.2499f, 8.625f)
                horizontalLineTo(16.125f)
                verticalLineTo(8.625f)
                moveTo(8.6178f, 8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                verticalLineTo(8.6178f)
                moveTo(6.6534f, 7.2144f)
                curveTo(6.8072f, 7.2144f, 6.9348f, 7.1612f, 7.0363f, 7.0547f)
                curveTo(7.1377f, 6.9482f, 7.1884f, 6.824f, 7.1884f, 6.6821f)
                curveTo(7.1884f, 6.5283f, 7.1377f, 6.4007f, 7.0364f, 6.2993f)
                curveTo(6.935f, 6.1978f, 6.8067f, 6.1471f, 6.6517f, 6.1471f)
                curveTo(6.5086f, 6.1471f, 6.3843f, 6.1978f, 6.2791f, 6.2992f)
                curveTo(6.1738f, 6.4006f, 6.1211f, 6.5288f, 6.1211f, 6.6838f)
                curveTo(6.1211f, 6.827f, 6.1744f, 6.9512f, 6.2808f, 7.0565f)
                curveTo(6.3873f, 7.1617f, 6.5115f, 7.2144f, 6.6534f, 7.2144f)
                verticalLineTo(7.2144f)
            }
        }
        .build()
        return _rotateOutline!!
    }

private var _rotateOutline: ImageVector? = null
